import './style.scss';
import { dashPlayerInit } from './scripts/dash_player/dashPlayerInit';
import { tmdbModuleInit } from './scripts/tmdb/tmdbModuleInit';

const underlineAnimation = el => {
  if (!el) return;
  el.addEventListener('mouseenter', () => {
    el.classList.remove('anim--leave');
    void el.offsetWidth;
    el.classList.add('anim--enter');
  });

  el.addEventListener('mouseleave', () => {
    el.classList.remove('anim--enter');
    void el.offsetWidth;
    el.classList.add('anim--leave');
  });
};

// Function to initialize the video player and fade-out logic
const videoPlayerInit = () => {
  const videoPlayer = document.getElementById('videoPlayer');
  const playButton = document.querySelector('.header_trailer-play');
  const closeButton = document.getElementById('closeButton');
  const section = document.querySelector('.header_trailer');

  // Check if elements exist before adding event listeners
  if (videoPlayer && playButton && closeButton && section) {
    underlineAnimation(playButton);

    playButton.addEventListener('click', () => {
      videoPlayer.style.display = 'block';
      videoPlayer.play();
      section.classList.add('header_trailer-fade-out');
    });

    closeButton.addEventListener('click', () => {
      videoPlayer.pause();
      videoPlayer.style.display = 'none';
      section.classList.remove('header_trailer-fade-out');
    });
  }
};

// Consolidate initialization
const moduleInit = () => {
  dashPlayerInit();
  tmdbModuleInit();
  videoPlayerInit(); // Initialize video player logic here

  // New function to set fixed height
  const headerTrailer = document.querySelector('.header_trailer');
  const setInitialHeight = () => {
    const viewportHeight = window.innerHeight;
    headerTrailer.style.height = viewportHeight + 'px';
  };
  // setInitialHeight();
  // window.addEventListener('orientationchange', setInitialHeight);
};

// Single DOMContentLoaded listener for better performance and structure
document.addEventListener('DOMContentLoaded', moduleInit);
